// Root `machine(id:)` queries don't all select `id`: the machine object is
// stored inline under `machine({"id":…})`, and without a merge policy each
// write REPLACES the previous selection — "Cache data may be lost when
// replacing the machine field of a Query object" + avoidable refetches.
// `merge: true` is safe here because the field key includes the `id`
// argument: two different machines never share an entry.
const typePolicies = {
  Query: {
    fields: {
      machine: {
        merge: true,
      },
    },
  },
};

export default typePolicies;
